import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './location-item.scss';

class LocationItem extends PureComponent {
  render() {
    const { suggestion, className, getSuggestionItemProps } = this.props; 

    return (
      <div
        {...getSuggestionItemProps(suggestion, {
          className
        })}
      >
        <span>{suggestion.description}</span>
      </div>
    );
  }
}

LocationItem.propTypes = {

};

export default LocationItem;